import { defineCustomElements as defineCustomElementsDesignSystem } from '@suits/ss-design-system/loader'
import { defineCustomElements } from '@susu/booking-tool/loader'
import log from '@susu/headless-commerce/utils/log'
import { useEffect } from 'react'

export function useBookingTool() {
  useEffect(() => {
    try {
      defineCustomElements(window)
    } catch (error) {
      log.error(error)
    }

    try {
      defineCustomElementsDesignSystem(window)
    } catch (error) {
      log.error(error)
    }
  })
}
